import Image from "next/image"
import { useTranslation } from "next-i18next";

const DiscoverPowerOfMakdos = () => {
    const { t } = useTranslation(["common", "windowsCloudServer"]);

    return (
        <div className="relative px-4 py-10 lg:px-0 services bg-makdosSecondaryGray lg:py-20">
            <div className="container mx-auto">
                <h2 className="text-3xl mb-3 lg:mb-5 lg:text-[40px] lg:text-center font-bold">{t("common:discoverPowerOfMakdos")}</h2>
                <div className="mx-auto lg:mx-[210px] text-sm lg:text-base lg:text-center text-cardText" dangerouslySetInnerHTML={{ __html: t("common:discoverPowerOfMakdosDesc") }}></div>
                <div className="flex items-center justify-center mt-10">
                    <Image
                        src={"/PowerOfMakdos.svg"}
                        width={563}
                        height={494}
                        alt={t("common:discoverPowerOfMakdos")}
                        title={t("common:discoverPowerOfMakdos")}
                    />
                </div>
            </div>
        </div>
    )
}

export default DiscoverPowerOfMakdos